module.exports = __webpack_public_path__ + "static/media/13.3554ff81.png";